import type { DataTableColumn } from '@odo/shared-ui';
import { CollapsibleCell } from './CollapsibleCell';

export function withRowExit<T extends { leaving: boolean }, K extends string>(
    column: DataTableColumn<T, K>
): DataTableColumn<T, K> {
    const { render } = column;
    return {
        ...column,
        render: (row, index) => (
            <CollapsibleCell collapsed={row.leaving}>{render(row, index)}</CollapsibleCell>
        )
    };
}
